import {
  DatePipe,
  JsonPipe,
  KeyValuePipe,
  NgForOf,
  NgIf,
} from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
} from '@angular/core';
import {
  CopyToClipboardComponent,
  JsonViewerComponent,
} from '@rxap/components';
import { DataGridModule } from '@rxap/data-grid';
import { RXAP_ENVIRONMENT } from '@rxap/environment';
import { IErrorDialogComponent } from '../error-dialog/error-dialog.component';
import { EUROGARD_ERROR_DIALOG_ERROR } from '../tokens';
import { AnyHttpErrorDialogData } from './any-http-error-dialog-data';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'eurogard-any-http-error',
  templateUrl: './any-http-error.component.html',
  styleUrls: [ './any-http-error.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    DataGridModule,
    NgIf,
    DatePipe,
    KeyValuePipe,
    NgForOf,
    CopyToClipboardComponent,
    JsonPipe,
    JsonViewerComponent,
    MatIcon,
    MatButton,
  ],
})
export class AnyHttpErrorComponent implements IErrorDialogComponent<AnyHttpErrorDialogData> {

  protected showHeaders = false;

  public readonly isProduction: boolean = inject(RXAP_ENVIRONMENT, { optional: true })?.production ?? false;

  public readonly error: AnyHttpErrorDialogData = inject(EUROGARD_ERROR_DIALOG_ERROR);

  protected isJson(value: any): boolean {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
  }
}
